import React from 'react';
import { Field, reduxForm } from 'redux-form';
import LocalityField from './localityField';
import { Input } from '../../util/controls';
import { required, poBox } from '../../util/validations';

let addressEdit = props => {
    const { handleSubmit, pristine, submitting, localities, getLocalities, clearLocalities } = props;

    return (
        <div>
            <h3>Update Address</h3>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="alert alert-warning text-center" role="alert">
                                We do not accept PO Box or RMB addresses.
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="name">Address Line 1</label>
                                <Field name="address" component={Input} type="text" className="form-control" validate={[poBox]} />
                            </div>
                            <div className="form-group">
                                <label className="control-label" htmlFor="name">Address Line 2</label>
                                <Field name="address2" component={Input} type="text" className="form-control" validate={[poBox]} />
                            </div>
                            <Field
                                name="locality"
                                label="City/Postcode"
                                placeholder="Enter a city or postcode"
                                component={LocalityField}
                                type="text"
                                inputClassName="form-control"
                                onSuggestionsFetch={getLocalities}
                                onSuggestionsClear={clearLocalities}
                                suggestions={localities}
                                validate={[required]} />
                        </div>
                    </div>
                </div>
                <button type="submit" disabled={pristine || submitting} className="btn btn-client btn-lg btn-block">Submit</button>
                <button type="button" className="btn btn-client-alt btn-lg btn-block" onClick={props.onCancel}>Cancel</button>
            </form>
        </div>
    );

};

addressEdit = reduxForm({
    form: 'address'
})(addressEdit);

export default addressEdit;


// WEBPACK FOOTER //
// ./app/address/components/addressEdit.js